import { Box, Container, Grid, Link, Typography, TypographyProps } from "@mui/material";
import { memberTheme } from "../memberTheme";
import ThirtyEightDegreesLogo from "@flow/frontend/common/ThirtyEightDegreesLogo";

const FooterTypography = (props: TypographyProps & { href: string }) => {
  const { children, href } = props;
  // line height maybe removed in future if we adjust global line height to match this
  return (
    <Link
      href={href}
      rel="noopener"
      fontSize={"0.75rem"}
      sx={{ flex: 1, color: memberTheme.palette.primary.contrastText }}
      underline="none"
    >
      {children}
    </Link>
  );
};

export const Footer = () => {
  const logoLink = (
    <Link href="/" title="38 Degrees">
      <Box
        component="span"
        title="38 Degrees Logo"
        sx={{
          width: { xs: "12rem", md: "14rem" },
          display: "inline-block",
          paddingBottom: { md: "1rem" },
        }}
      >
        <ThirtyEightDegreesLogo colour={"#FFFFFF"} />
      </Box>
    </Link>
  );

  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        height: "auto",
        backgroundColor: memberTheme.palette.primary.dark,
        padding: { md: "1.75rem 0", xs: "1.75rem" },
      }}
    >
      <Grid container rowSpacing={{ xs: 3 }} justifyContent="center" sx={{ marginTop: "0" }}>
        <Grid item xs={12} order={{ xs: 1 }} sx={{ display: { xs: "block", sm: "none" } }}>
          {logoLink}
        </Grid>
        <Grid item md={4} xs={12} order={{ xs: 3, sm: 1 }}>
          <Box sx={{ display: { xs: "none", sm: "block" } }}>{logoLink}</Box>
          <Typography color={memberTheme.palette.primary.contrastText} lineHeight={"1.5rem"} fontSize={"0.75rem"}>
            {/* TODO: DEVOPS-61 2024 Election banner. Remove whn no longer required. */}
            Promoted by 38 Degrees C/O Sedulo London Office 605, Albert House, 256-260 Old Street, C4R, 1BE, London.
            <hr />
            38 Degrees <sup>&reg;</sup> | {new Date().getFullYear()}
            <br />
            Limited by Guarantee Registered Company No.
            <br />
            06642193 in England and Wales Registered
            <br />
            Office: <br />
            C/O Sedulo London Office 605, Albert House, 256-260 Old Street
            <br />
            London
            <br />
            EC1V 9DD
          </Typography>
        </Grid>
        <Grid item md={4} xs={12} order={{ xs: 2, sm: 3 }}>
          <Grid container spacing={0.5} sx={{ height: "100%", padding: { xs: "0", sm: "3rem" } }}>
            <Grid item xs={6}>
              <Container
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                  padding: { xs: "0" },
                  gap: { xs: "0.75rem" },
                }}
              >
                <FooterTypography href="https://home.38degrees.org.uk/campaigns">Campaigns</FooterTypography>
                <FooterTypography href="https://home.38degrees.org.uk/news">Latest News</FooterTypography>
                <FooterTypography href="https://home.38degrees.org.uk/about/#contact">Contact us</FooterTypography>
                <FooterTypography href="https://home.38degrees.org.uk/privacy-policy">Privacy Policy</FooterTypography>
              </Container>
            </Grid>
            <Grid item xs={6}>
              <Container
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between", // Vertically space items evenly
                  height: "100%",
                  padding: { xs: "0" },
                  gap: { xs: "0.75rem" },
                }}
              >
                <FooterTypography href="https://home.38degrees.org.uk/about/#donation-policy">
                  Donations Policy
                </FooterTypography>
                <FooterTypography href="https://home.38degrees.org.uk/careers">Careers</FooterTypography>
                <FooterTypography href="https://you.38degrees.org.uk/petition/start?source=38homefooter">
                  Start a petition
                </FooterTypography>
                <FooterTypography href="https://you.38degrees.org.uk/tos">Terms of Service</FooterTypography>
              </Container>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
